import React from 'react';
import { Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { InvestmentBudgetRollupRow } from './types';
import { formatMoney, formatNumber } from './format';

type Props = { rows: InvestmentBudgetRollupRow[] };

const InvestmentBudgetRollupPanel: React.FC<Props> = ({ rows }) => (
  <Paper elevation={1} sx={{ p: 2 }}>
    <Typography variant="h6" sx={{ mb: 2 }}>Investment Budget Rollup</Typography>
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Cost Center</TableCell>
          <TableCell>Type</TableCell>
          <TableCell>Priority</TableCell>
          <TableCell>Account</TableCell>
          <TableCell align="right">Lines</TableCell>
          <TableCell align="right">Requested</TableCell>
          <TableCell align="right">Approved</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row, idx) => (
          <TableRow key={`${row.ccc}-${row.ivt}-${row.prc}-${idx}`} hover>
            <TableCell>{row.ccc} {row.ccn}</TableCell>
            <TableCell>{row.ivt}</TableCell>
            <TableCell>{row.prc}</TableCell>
            <TableCell>{row.acc} {row.acn}</TableCell>
            <TableCell align="right">{formatNumber(row.linecount)}</TableCell>
            <TableCell align="right">{formatMoney(row.requestedamount)}</TableCell>
            <TableCell align="right">{formatMoney(row.approvedamount)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Paper>
);

export default InvestmentBudgetRollupPanel;
